import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IProduct } from "../../types/api";
import { IDrugCard } from "../../types/apis/drugs";
import { ItemsManagementSliceInterface } from "../../types/reduxSlices";

const initialState: ItemsManagementSliceInterface = {
  showDeleteProductPopup: false,
  showDeleteDrugPopup: false,
  showDeleteOfferPopup: false,
  showEndOfferPopup: false,
  selectedDrug: null,
  selectedProduct: null,
  selectedItems: [],
  showDeletePopup: false,
  selectedRowItem: null,
};

const ItemsManagementSlice = createSlice({
  name: "ItemsManagement",
  initialState,
  reducers: {
    handleShowDeleteProductPopup: (state, action: PayloadAction<boolean>) => {
      state.showDeleteProductPopup = action.payload;
    },
    handleShowDeleteDrugPopup: (state, action: PayloadAction<boolean>) => {
      state.showDeleteDrugPopup = action.payload;
    },
    handleShowDeleteOfferPopup: (state, action: PayloadAction<boolean>) => {
      state.showDeleteOfferPopup = action.payload;
    },
    handleShowEndOfferPopup: (state, action: PayloadAction<boolean>) => {
      state.showEndOfferPopup = action.payload;
    },
    handleUpdateSelectedDrug: (
      state,
      action: PayloadAction<IDrugCard | null>,
    ) => {
      state.selectedDrug = action.payload;
    },
    handleUpdateSelectedProduct: (
      state,
      action: PayloadAction<IProduct | null>,
    ) => {
      state.selectedProduct = action.payload;
    },
    handleUpdateSelectedItems: (state, action: PayloadAction<any | null>) => {
      state.selectedItems = action.payload;
    },
    handleSetSelectedRowItem: (state, action: PayloadAction<any>) => {
      state.selectedRowItem = action.payload;
    },
    handleShowDeletePopup: (state, action: PayloadAction<boolean>) => {
      state.showDeletePopup = action.payload;
    },
  },
});

export const {
  handleShowDeleteProductPopup,
  handleShowDeleteDrugPopup,
  handleShowDeleteOfferPopup,
  handleShowEndOfferPopup,
  handleUpdateSelectedDrug,
  handleUpdateSelectedProduct,
  handleUpdateSelectedItems,
  handleShowDeletePopup,
  handleSetSelectedRowItem,
} = ItemsManagementSlice.actions;

export default ItemsManagementSlice.reducer;
